import React, { useState } from 'react'
// import video from '../../assets/videos/Video Examen de Conocimientos Concurso 2025 DEPGFMLUZ.mp4'
import ReactPlayer from 'react-player'
import ubicacionesPdf from '../../assets/files/Concurso/Concurso 2025 Distribucion Web.pdf'
import entrevistasSabado from '../../assets/files/Concurso/Entrevistas Sabado.pdf'
import entrevistasPosterior from '../../assets/files/Concurso/Entrevistas a Posterior.pdf'
import { Dropdown } from 'react-bootstrap'

const ConcursoPrueba = () => {

  const [videoReadyStatus, setVideoReadyStatus] = useState(false);
  
  const toggleVideoStatus = () => {
    setVideoReadyStatus(true);
  }

  return (
    <div className='page-section instructivos prueba-con'>
        <section className='video-container'>
          <div className={`video-canvas ${ videoReadyStatus ? 'ready' : 'loading' }`}>
            <button 
              className={`video-placeholder btn btn-secondary disabled placeholder-wave d-${videoReadyStatus ? 'none' : 'block'}`} 
            ></button>
            <div className={`d-${ videoReadyStatus ? 'block' : 'none' }`}>
              <ReactPlayer
                className='video-player'
                url={null}
                playing={false}
                volume={0.65}
                controls={true}
                width={'100%'}
                height={'auto'}
                onReady={toggleVideoStatus}
              />
            </div>
          </div>
          <div className='button-group d-flex flex-column'>
            <a href={ubicacionesPdf} download={'Concurso 2025 Distribucion Web'} className='btn-baremo btn btn-primary link-button'>
              Ubicación de Aulas
            </a>
            {/* <Link to={'/ubicaciones-concurso'} target='blank' className='btn-baremo btn btn-primary link-button'>
              Consultar Ubicación
            </Link> */}
            <Dropdown className='entrevista-dropdown' drop='down-centered'>
              <Dropdown.Toggle className='link-button w-100' variant="primary" id="dropdown-basic">
                Entrevistas
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.ItemText className='link-button bg-primary'>
                  <a className='drop-link' href={entrevistasSabado} download={'Entrevistas Sábado - Concurso 2025 DEPGFMLUZ'} >
                    Entrevistas Sábado
                  </a>
                </Dropdown.ItemText>
                <Dropdown.ItemText className='link-button bg-primary'>
                  <a className='drop-link' href={entrevistasPosterior} download={'Entrevistas a Posterior - Concurso 2025 DEPGFMLUZ'} >
                    Entrevistas a Posterior
                  </a>
                </Dropdown.ItemText>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </section>

        <section className='info-container' id='index'>
          {/* <p className='heading-p'></p> */}
          
          <h3 className='section-title'>Examen de Conocimientos 2025</h3>
          
          <div className='info-group'>
            {/* <h3 className='modal-subtitle spaced'>Cronograma</h3> */}
            <p dangerouslySetInnerHTML={{__html: '<b>Fecha: </b> Sábado 11 de octubre de 2025'}} />
            <p dangerouslySetInnerHTML={{__html: '<b>Hora: </b> 8:00 AM'}}/>
            <p dangerouslySetInnerHTML={{__html: '<b>Lugar:</b> Edificio Ciencia y Salud. Facultad de Medicina. '}}></p>
            <div className='span-group mb-0'>
              <span className='span-lead'>Hora recomendada de llegada: </span>
              <span>6:00 AM</span>
            </div>
          </div>
          <div className='info-group list-column'>
            <h4 className='group-title'>Asistir con: </h4>
            <p>✔  Bata médica blanca</p>
            <p>✔  Documento de identidad</p>
            <p>✔  Lápiz grafito, sacapuntas y borrador</p>
          </div>
          <div className='info-group list-column'>
            <h4 className='group-title'>Importante: </h4>

            <p>- No se permitirá la entrada de celulares, ni relojes, ni lentes inteligentes o cualquier dispositivo asociado a inteligencia artificial. </p>
            <p>- No se permitirá la entrada con carteras o bolsos. </p>
            <p>- No se permitirán acompañantes. </p>
          </div>
        </section>
    </div>
  )
}

export { ConcursoPrueba }